import React from "react";
import LoadingButton from "../../dumb/LoadingButton";
import useModal from "../../../hook/useModal";
import useStatusThunk from "../../../hook/useStatusThunk";
import DisplayError from "../../dumb/DisplayError";
import { useState } from "react";
import TextInput from "../../dumb/TextInput";
import { setTitleName } from "../../../redux/ducks/title";

const SetTitleName = props => {
    const [show, hide, renderModal] = useModal();
    const [d_setTitleName, status, error, event] = useStatusThunk(setTitleName);
    const [name, setName] = useState();

    event.onSuccess = () => {
        hide();
        setName();
    }

    return (
        <React.Fragment>
            <button className={"button icon-button " + props.className} onClick={show}><i className="fas fa-pencil-alt"></i></button>
            {renderModal(
                <div>
                    <div className="group">
                        <div className="label">Title name</div>
                        <TextInput set={setName} v={name} />
                    </div>

                    <div className="group">
                        <DisplayError error={error} />
                    </div>

                    {<LoadingButton loading={status == "pending"} onClick={e => d_setTitleName({titleID: props.titleID, titleName:name})} className="button--primary">Set name</LoadingButton>}
                </div>
            )}
        </React.Fragment>
    )
}

export default SetTitleName;